import { BuilderConfig } from '@/types/Builder';

import { B2BScrollingContent, B2BScrollingContentProps } from './b2b-scrolling-content';

export const B2BScrollingContentBuilderConfig = {
    name: 'B2B Scrolling Content',
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'sections',
            type: 'list',
            copyOnAdd: false,
            subFields: [
                {
                    name: 'title',
                    type: 'string',
                },
                {
                    name: 'description',
                    type: 'string',
                },
                {
                    name: 'image',
                    type: 'file',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BScrollingContentProps> = {
    component: B2BScrollingContent,
    config: B2BScrollingContentBuilderConfig,
};

export default builderConfig;
